import { useStrings } from '../tenant/TenantProvider';
import { formatCountdown } from '../lib/format';
import { cx } from './cx';

const pad = (value) => String(value).padStart(2, '0');

export function Countdown({ ms, className, size }) {
  const t = useStrings();
  const total = Math.max(0, Math.floor(ms / 1000));
  const days = Math.floor(total / 86400);
  const hours = Math.floor((total % 86400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  const parts = [
    ...(days > 0 ? [['days', days]] : []),
    ['hours', hours],
    ['minutes', minutes],
    ['seconds', seconds],
  ];

  return (
    <span className={cx('countdown', size && `countdown--${size}`, className)} role="timer" aria-label={formatCountdown(ms)}>
      {parts.map(([unit, value]) => (
        <span key={unit} className="countdown__part" aria-hidden="true">
          <span className="countdown__value">
            <span key={value} className="countdown__digits">
              {pad(value)}
            </span>
          </span>
          <span className="countdown__unit">{t(`common.units.${unit}`)}</span>
        </span>
      ))}
    </span>
  );
}
